import _ from 'underscore';
import { useEffect, useCallback, useState } from 'react';

const ThrottleDelay = 10;

export const getColumnsForWidth = (width: number) => {
  if (width >= 875) return 3;
  if (width >= 578) return 2;
  return 1;
};

export const useCreativesListColumns = (ref: React.RefObject<HTMLDivElement>) => {
  const [columns, setColumns] = useState<number>();

  const onObservation = useCallback(_.throttle((entries: any) => {
    if (_.isEmpty(entries)) return;
    const newColumns = getColumnsForWidth(entries[0].contentRect.width);
    setColumns(newColumns);
  }, ThrottleDelay), []);

  useEffect(() => {
    const resizeObserver = new (window as any).ResizeObserver(onObservation);
    resizeObserver.observe(ref.current!.parentElement);
    return () => resizeObserver.disconnect();
  }, [onObservation]);

  return columns;
};
